import BasicResource from '@/api/resource';

class ProfileResource extends BasicResource {

    constructor () {
        super('user-profile');
    }

    update (data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}`,
            data: data,
        });
    }

    getStorageItems (params) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/storage`,
            params,
        });
    }

    getStorageItemById (itemId) {
        return this.client.request({
            method: 'get',
            path: `/upyield/v1/${this.resourceName}/storage/${itemId}`,
        });
    }

    postStorageItem (data) {
        return this.client.request({
            method: 'post',
            path: `/upyield/v1/${this.resourceName}/storage`,
            data,
        });
    }

    updateStorageItem (itemId, data) {
        return this.client.request({
            method: 'put',
            path: `/upyield/v1/${this.resourceName}/storage/${itemId}`,
            data,
        });
    }

    deleteStorageItem (itemId) {
        return this.client.request({
            method: 'delete',
            path: `/upyield/v1/${this.resourceName}/storage/${itemId}`,
        });
    }
}

export default new ProfileResource;
